module.exports = __webpack_public_path__ + "static/media/7.62c864f7.svg";